<div class="messages-section box_default box_white">
  <header>
    <h3>MESSAGES</h3>
  </header>
  <div class="loader">
    <div class="dimmed" [hidden]="versionMessages != null && access != null">
      <div class="dimmed_avatar"></div>
      <div class="dimmed_info">
        <div class="dimmed_title"></div>
        <div class="dimmed_subtitle"></div>
      </div>
    </div>
    <!--  <core-helpers-box-loading [hidden]="versionMessages != null && access != null"></core-helpers-box-loading> -->
  </div>

  <article *ngIf="versionMessages != null && access != null" class="messages-section-main">
   
    <!-- add form checking access-->
    <div class="version-messages-form" *ngIf="access.access_version_write_comments">
      <core-message-add
            [action]="messageAddUrl"
            (onSaved)="onUpdateMessages($event)">
        </core-message-add>
    </div>
    <!-- list -->
    <div class="version-details-comments-list">
      <article *ngIf="versionMessages!=null && versionMessages.length==0" class="message-not-content">
        <core-helpers-box-alert-message-icon
          [text]="'There are currently no messages.'"
          [icon]="'no_messages'"
        ></core-helpers-box-alert-message-icon>
      </article>
      <ul class="comments-list" *ngIf="versionMessages.length > 0">
        <li class="comments-timeline-item" *ngFor="let vmessage of versionMessages | sortBy: 'date' : 'desc'">
            <core-message
                *ngIf="vmessage.message"
                [message]="vmessage.message"
                [notesActionText]="access.access_version_write_comments ? 'Add Notes' : 'See Notes'"
                [notesActionStyle]="access.access_version_write_comments ? 'add-notes' : 'see-notes'"
                [canCreateNotes]="access.access_version_write_comments"
                [delete]="vmessage.message.user.id == user.id"
                (onDelete)="onDeleteMessage($event)"
                [prefixUrl]="prefixUrl"
            ></core-message>
        </li>
      </ul>
    </div>
  </article>
</div>
